var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKitchen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 68.17 73.9",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "5px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.58 14.16h-4.77c-6.8 0-12.31 5.51-12.31 12.31s5.51 12.31 12.31 12.31h2.27v32.62h34.01v-32.62h2.27c6.8 0 12.31-5.51 12.31-12.31s-5.51-12.31-12.31-12.31h-4.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.23 17.35c0-8.2 6.65-14.85 14.85-14.85s14.85 6.65 14.85 14.85"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.08,
    x2: 51.09,
    y1: 56.49,
    y2: 56.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.08,
    x2: 26.08,
    y1: 40.73,
    y2: 47.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.09,
    x2: 34.09,
    y1: 40.73,
    y2: 47.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.02,
    x2: 42.02,
    y1: 40.73,
    y2: 47.83
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchen);
export default __webpack_public_path__ + "static/media/kitchen.38ee70c2.svg";
export { ForwardRef as ReactComponent };